import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatListModule } from '@angular/material/list'

export interface LegalDialogData {
  nutzungsbedinungenUrl: string
  datenschutzUrl: string
}

@Component({
  imports: [MatDialogModule, MatButtonModule, MatListModule, MatIconModule],
  templateUrl: './legal-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './legal-dialog.component.scss',
})
export class LegalDialogComponent {
  private readonly data?: LegalDialogData = inject(MAT_DIALOG_DATA)

  readonly legalLinks: { label: string; url: string; icon: string }[] = [
    {
      label: 'Impressum',
      url: 'https://www.saniup.de/impressum',
      icon: 'gavel',
    },
    {
      label: 'Datenschutz',
      url: this.data?.datenschutzUrl ?? 'https://www.saniup.de/datenschutz',
      icon: 'admin_panel_settings',
    },
    {
      label: 'Nutzungsbedingungen',
      url: this.data?.nutzungsbedinungenUrl ?? 'https://saniup-app.webflow.io/nutzungsbedingungen-app-website',
      icon: 'contract',
    },
    {
      label: 'Pflichtangaben (HWG und Biozid)',
      url: 'https://www.saniup.de/pflichtangaben-produkte-hwg-biozide',
      icon: 'person',
    },
  ]
}
